module.exports = new __parcel__URL__("logo_crc.eeb919ba.jpg").toString();